"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = ({
  size = 16,
  width = size,
  height = size,
  ...restProps
}) => /*#__PURE__*/_react.default.createElement("svg", _extends({
  width: width,
  height: height,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, restProps), /*#__PURE__*/_react.default.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/_react.default.createElement("rect", {
  width: "16",
  height: "16",
  rx: "2",
  fill: "#0D62FF"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M4.28033 7.94163C3.98744 7.64874 3.51256 7.64874 3.21967 7.94163C2.92678 8.23452 2.92678 8.7094 3.21967 9.00229L5.94202 11.7246C6.23491 12.0175 6.70979 12.0175 7.00268 11.7246L13.447 5.28033C13.7399 4.98744 13.7399 4.51256 13.447 4.21967C13.1541 3.92678 12.6792 3.92678 12.3863 4.21967L6.47235 10.1337L4.28033 7.94163Z",
  fill: "white"
})), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M0 1.6C0 0.716345 0.716344 0 1.6 0L14.4 0C15.2837 0 16 0.716344 16 1.6L16 14.4C16 15.2837 15.2837 16 14.4 16L1.6 16C0.716345 16 0 15.2837 0 14.4L0 1.6Z",
  fill: "white"
}))));

exports.default = _default;